import React from 'react';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';

// {touched &&
//   (error && (
//     <Message negative compact tiny style={{ marginTop: '0' }}>
//       <Message.Header>{error}</Message.Header>
//     </Message>
//   ))}

const ReduxField = ({
  input,
  label,
  type,
  icon,
  meta: { active, touched, error, warning },
  meta,
}) => {
  let i = icon;
  if (input.name === 'username' && input.value && input.value.length > 1) {
    if (error) {
      i = 'remove circle';
    } else {
      i = 'check circle';
    }
  }

  const isGame = touched || (active && input.value.length > 1);
  let hasError = false;
  if (isGame && error) {
    hasError = true;
  }
  return (
    <div className="field">
      <Form.Input
        error={hasError}
        // iconPosition="right"
        icon={i}
        type={type}
        size="big"
        {...input}
        placeholder={label}
      />
      {isGame &&
        (error && (
          <Message style={{ marginTop: '0' }} negative compact>
            {error}
          </Message>
        ))}
    </div>
  );
};

ReduxField.defaultProps = {
  icon: null,
  label: null,
  type: null,
  meta: null,
};

ReduxField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.string,
  meta: PropTypes.object,
};

export default ReduxField;



// WEBPACK FOOTER //
// ./src/containers/Signup/components/ReduxField/index.jsx